import styled from "styled-components";
import { COLORS, SIZES, WEIGHT } from "../theme";
import { Radio } from "antd";

export const Inner = styled.div`
	padding: 30px 100px;
	background-color: ${COLORS.LightGrey};
	min-height: 65vh;

	@media only screen and (min-width: 600px) and (max-width: 860px) {
	}
`;
export const Header = styled.div`
	margin-bottom: 30px;
`;
export const Breadcrumb = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	margin-bottom: 5px;
`;

export const ActiveBreadcrumbItem = styled.span`
	font-weight: ${WEIGHT.Bold};
	color: ${COLORS.Primary};
	font-size: ${SIZES.level6};
`;

export const BreadcrumbItem = styled.span`
	font-size: ${SIZES.level7};
`;

export const BreadcrumbSeparator = styled.div`
	font-size: ${SIZES.level8};
	font-weight: ${WEIGHT.Black};
`;
export const Title = styled.div`
	margin-bottom: 5px;
`;
export const SubTitle = styled.div`
	margin: 10px 0 15px 0;
`;
export const Body = styled.div`
	& .noBackground,
	& .noBackground:hover {
		background-color: ${COLORS.LightGrey} !important;
		border: none;
	}
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	align-items: center;

	.ant-picker,
	.ant-select-selector {
		height: 35px !important;
		border-radius: 14px !important;
		border: 1px solid #cbd5e1 !important;
		box-shadow: none !important;
		font-size: 16px !important;
	}

	.ant-picker {
		padding: 0 16px !important;
	}

	.ant-select-selector {
		padding: 0 16px !important;
		display: flex !important;
		align-items: center !important;
	}

	.ant-select-selection-placeholder,
	.ant-select-selection-item {
		color: #334155 !important;
		font-size: 16px !important;
	}

	.ant-picker:hover,
	.ant-picker-focused,
	.ant-select-focused .ant-select-selector,
	.ant-select:hover .ant-select-selector {
		border-color: #4f46e5 !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	.ant-picker-range {
		min-width: 260px;
	}

	@media only screen and (max-width: 1200px) {
		.ant-picker-range,
		.ant-select,
		.ant-input-affix-wrapper {
			flex: 1 1 220px;
			min-width: 220px;
		}
	}

	@media only screen and (max-width: 768px) {
		.ant-picker-range,
		.ant-select,
		.ant-input-affix-wrapper {
			width: 100%;
			min-width: 100%;
		}
	}
`;

export const FilterSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const FilterActions = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	margin-left: auto;

	@media only screen and (max-width: 1200px) {
		margin-left: 0;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;
